import React, { useCallback, useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { BasecampLayout, AreaLayout } from '../../components/Layout';
import { PageHeader, Card, Spinner, Alert, EmptyState, Btn, Input } from '../../components/UI';
import { api } from '../../utils/api';

const SUBNAV = [
  { href: '/ongoing/tasks', label: 'My Tasks' },
];

function Loading() {
  return <div style={{ display: 'flex', justifyContent: 'center', padding: '60px' }}><Spinner /></div>;
}

function Tasks() {
  const [state, setState] = useState({ loading: true, error: null, tasks: [] });
  const [title, setTitle] = useState('');

  const load = useCallback(() => {
    api.getTasks()
      .then(d => setState({ loading: false, error: null, tasks: d.tasks }))
      .catch(e => setState({ loading: false, error: e.message, tasks: [] }));
  }, []);
  useEffect(() => { load(); }, [load]);

  async function add(e) {
    e.preventDefault();
    if (!title.trim()) return;
    try { await api.createTask(title); setTitle(''); load(); } catch (err) { alert(err.message); }
  }
  async function toggle(t) { try { await api.toggleTask(t.id, !t.done); load(); } catch (e) { alert(e.message); } }
  async function remove(t) { try { await api.deleteTask(t.id); load(); } catch (e) { alert(e.message); } }

  if (state.loading) return <Loading />;
  if (state.error) return <Alert type="error">{state.error}</Alert>;

  return (
    <>
      <Alert type="info">Personal tasks, plus system events arriving automatically — approvals waiting, day preparation due.</Alert>
      <form onSubmit={add} style={{ display: 'flex', gap: 10, margin: '18px 0', maxWidth: 480 }}>
        <Input placeholder="New task" value={title} onChange={e => setTitle(e.target.value)} />
        <Btn type="submit">Add</Btn>
      </form>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 640 }}>
        {state.tasks.map(t => (
          <Card key={t.id} style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
            <input type="checkbox" checked={t.done} onChange={() => toggle(t)} style={{ width: 16, height: 16, cursor: 'pointer' }} />
            <span style={{
              flex: 1, fontSize: '0.9rem',
              textDecoration: t.done ? 'line-through' : 'none',
              color: t.done ? 'var(--ink-faint)' : 'var(--ink)',
            }}>
              {t.title}
              {t.source === 'system' && (
                <span style={{ marginLeft: 8, fontSize: '0.65rem', padding: '1px 7px', borderRadius: 99, background: 'var(--canvas-warm)', color: 'var(--ink-soft)', fontWeight: 600 }}>SYSTEM</span>
              )}
            </span>
            <button onClick={() => remove(t)} style={{ color: 'var(--ink-faint)', fontSize: '1rem' }}>×</button>
          </Card>
        ))}
        {state.tasks.length === 0 && <EmptyState icon="✓" title="No tasks" message="You're all caught up." />}
      </div>
    </>
  );
}

export default function OngoingPages() {
  const { sub } = useParams();
  if (!sub) return <Navigate to="/ongoing/tasks" replace />;

  let body;
  if (sub === 'tasks') body = <Tasks />;
  else return <Navigate to="/ongoing/tasks" replace />;

  return (
    <BasecampLayout>
      <PageHeader title="Ongoing Things" subtitle="Personal tasks and active items" />
      <AreaLayout items={SUBNAV}>{body}</AreaLayout>
    </BasecampLayout>
  );
}